import FeatureFlagBase from './../shared/featureflag-base';
import { computed } from 'mobx';
import { serializable } from 'serializr';
import _ from 'lodash';

class FeatureFlag extends FeatureFlagBase {
    constructor(...args) {
        super(...args);
    }
}

export default FeatureFlag;



// WEBPACK FOOTER //
// ./src/featureflags/featureflag-model.js